import { render, staticRenderFns } from "./page-subtitle.vue?vue&type=template&id=28b28c0a"
import script from "./page-subtitle.vue?vue&type=script&lang=js"
export * from "./page-subtitle.vue?vue&type=script&lang=js"
import style0 from "./page-subtitle.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports